import Storage from '@common/services/storage';
import { getDefaultPromotions, usesLocalPromotionsSource } from '@common/utils/promotions';
import {
  PROMOTIONS_DISMISSED_STORAGE_KEY,
  PROMOTIONS_DISMISS,
  PROMOTIONS_SET,
  type PromotionsAction,
  type PromotionsState,
} from '@common/types/promotions';

export const initialPromotionsState: PromotionsState = {
  items: [],
  loaded: false,
  dismissedKeys: [],
};

function readDismissedKeysFromStorage(): string[] {
  const stored = Storage.getObject(PROMOTIONS_DISMISSED_STORAGE_KEY);
  if (!Array.isArray(stored)) return [];

  return stored.filter((key): key is string => typeof key === 'string');
}

export function getInitialPromotionsState(
  preloadedDismissedKeys?: string[],
): PromotionsState {
  const dismissedKeys = preloadedDismissedKeys ?? readDismissedKeysFromStorage();

  const useLocalPromotions = usesLocalPromotionsSource();

  return {
    ...initialPromotionsState,
    items: useLocalPromotions ? getDefaultPromotions() : [],
    loaded: useLocalPromotions,
    dismissedKeys,
  };
}

export default function promotionsReducer(
  state = initialPromotionsState,
  action: PromotionsAction,
): PromotionsState {
  switch (action.type) {
    case PROMOTIONS_SET:
      return {
        ...state,
        items: action.items,
        loaded: true,
      };
    case PROMOTIONS_DISMISS: {
      if (state.dismissedKeys.includes(action.key)) return state;

      return {
        ...state,
        dismissedKeys: [...state.dismissedKeys, action.key],
      };
    }
    default:
      return state;
  }
}

export { PROMOTIONS_SET, PROMOTIONS_DISMISS };
